import { useEffect, useState } from "react"
import { CRMService } from "../../../../app/core/crm.service";
import { DataTable } from "../../../../components/data-table";
import { CRMNotesGridCols } from "./notesGridCols";

export const CRMNotes = () => {
    const [notesData, setNotesData] = useState<any>();
    const [loading, setLoading] = useState<boolean>();
    const initialPayload = { limit: 10, page: 0 };
    const [pageCount, setPageCount] = useState(initialPayload);

    useEffect(() => {
        getNotesData(initialPayload);
    }, []);

    const getNotesData = async (payload: any) => {
        try {
            const res = await CRMService.GETNOTES(payload);
            const result = res.results;
            result.forEach((item:any)=>{
                item.note_status = <div className={`fw-bold ${item.status === "COMPLETED"?"text-success":"text-danger"}`}>{item.status}</div>
            })
            setNotesData(res);
        }
        catch (error) {

        }
    }

    const onActions = (data: any) => { };

    const onSelectPaginator = (data: any) => {
        const pageData = { ...pageCount, page: data };
        let payload = { limit: pageData.limit, page: data  }
        setPageCount(payload);
        getNotesData(payload);
    }

    return (
        <div className="container-fluid content-bg-color">
            <h5 className="fw-bold primary-color mt-3">Notes</h5>
            {loading && (
                <div className="text-center p-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only"></span>
                    </div>
                </div>
            )}
            {!loading && (
                <>
                    <DataTable
                        tableData={notesData}
                        TableCols={CRMNotesGridCols}
                        pagination={true}
                        pageCount={pageCount}
                        onSelectPageChange={(e) => onSelectPaginator(e)}
                        onActions={(e) => onActions(e)}
                    />
                </>
            )}
        </div>
    )
}